import { BaseClickSchema } from '@space-core/datahub/hotmartClub'
import type { DeviceInfoProps } from '@space-core/hooks/useDeviceInfo'

export default class ClickToChangeCommunityTypeSchema extends BaseClickSchema {
  action: string
  role: string
  communityId: number
  communityType: string
  deviceInfo: DeviceInfoProps

  constructor({ communityId = 0, userRole, componentName, deviceInfo, communityType }) {
    super({
      componentName: componentName
    })
    this.action = 'click_to_change_community_type'
    this.role = userRole
    this.deviceInfo = deviceInfo
    this.communityId = communityId
    this.communityType = communityType
  }

  getDataHubEventData() {
    return {
      ...super.prepare(),
      communityId: this.communityId,
      communityType: this.communityType,
      hasAccessToTheCommunity: true,
      userRole: this.role,
      ...this.deviceInfo
    }
  }
}
